export default "__VITE_ASSET__BqxBbQe4__"